package com.milta.feature.route.presentation

import com.milta.feature.route.domain.entity.DeliveryDraft
import com.milta.feature.route.domain.entity.RouteBatchResult

/**
 * Retour 26/10 (demande 2) — the Enterprise route creation in 3 steps: 1 Livraisons, 2 Chauffeurs,
 * 3 Répartition. Steps 1 and 2 are [CreateRouteScreen]; step 3 is the existing
 * [RouteBatchPreviewScreen]. A driver's own route ("Créer ma tournée") has no steps.
 */
enum class CreateRouteStep { Deliveries, Drivers, Distribution }

/** Step 1 filter chips: "Toutes N" / "À corriger N". */
enum class DeliveryFilter { All, ToFix }

/**
 * R7 — what the split was computed from. Revisiting step 3 with the same fingerprint shows the same
 * split again without calling RoutaR; any change (a delivery added, removed or edited, a driver, the
 * loading address) recomputes it.
 */
data class RouteBatchFingerprint(
    val deliveries: List<DeliveryDraft>,
    val driverIds: Set<String>,
    val loadingAddressId: String?,
    val date: String,
    /** "Créer sans optimisation" (quota at 0) computes a different split than an optimized one. */
    val optimize: Boolean,
)

/**
 * R6 — what must survive the creation screen being left and rebuilt (the "+" import detour, step 3,
 * a tab switch): the current step, the loading address picked and the split already computed (not
 * sent yet). Held by the host next to the deliveries and the drivers picked, and handed back to a
 * new [CreateRouteViewModel]. Cleared once the routes are sent or the creation is left.
 *
 * The step 1 delivery search (open + text) is kept too, so it is found again after ✎; it is only
 * reset when closed, on step 2, on "Ajouter des livraisons" and when the creation is left
 * ([withoutSearch]).
 */
data class CreateRouteSession(
    val step: CreateRouteStep = CreateRouteStep.Deliveries,
    val loadingAddressId: String? = null,
    val filter: DeliveryFilter = DeliveryFilter.All,
    /** Split created by `POST /route-batches` and not sent yet; abandoned server-side before a recompute (R8). */
    val batch: RouteBatchResult? = null,
    val batchFingerprint: RouteBatchFingerprint? = null,
    val isSearchOpen: Boolean = false,
    val searchQuery: String = "",
) {
    /** The creation is left: the next visit starts without a search (the rest is kept). */
    fun withoutSearch(): CreateRouteSession = copy(isSearchOpen = false, searchQuery = "")
}
